'use client';

import Conditional from '@next-app/components/Conditional';
import SkeletonUI from '@next-app/components/Skeleton/Skeleton';
import {
  selectIsCheckoutDetailsLoaded,
  selectIsDigitalOrder,
  selectIsPaymentMethodStep,
  selectIsPureFurniture,
} from '@next-app/lib/features/checkout/CheckoutSelector';
import {
  selectIsLoggedIn,
  selectRewardsCustomer,
} from '@next-app/lib/features/InitSelectors';
import dynamic from 'next/dynamic';
import { useSelector } from 'react-redux';

const LakeshoreBucksCard = dynamic(
  () => import('../LakeshoreBucksCard/LakeshoreBucksCard'),
  {
    ssr: true,
    loading: () => <SkeletonUI width={'100%'} height={30} />,
  },
);

const LakeshoreBucks = () => {
  const isCheckoutDetailsLoaded = useSelector(selectIsCheckoutDetailsLoaded);
  const isDigitalOrder = useSelector(selectIsDigitalOrder);
  const isPureFurniture = useSelector(selectIsPureFurniture);
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const isPaymentMethodStep = useSelector(selectIsPaymentMethodStep);

  const { rewardPoints = 0, availableBucks = [] } =
    useSelector(selectRewardsCustomer) || {};

  return (
    <>
      <Conditional if={!isCheckoutDetailsLoaded}>
        <SkeletonUI width={'100%'} height={30} />
      </Conditional>
      <Conditional
        if={
          isCheckoutDetailsLoaded &&
          isLoggedIn &&
          (rewardPoints >= 500 || availableBucks?.length > 0) &&
          !isDigitalOrder &&
          !isPureFurniture &&
          isPaymentMethodStep
        }
      >
        <section className="my-ll-5">
          <LakeshoreBucksCard />
        </section>
      </Conditional>
    </>
  );
};

export default LakeshoreBucks;
